import React from "react";
import { Link } from "react-router-dom";
import Constants from "../Constants";
const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="footer">
      <div className="footer_holder">
        <div className="columns">
          <div className="column">
            <div className="wrap">
              <div className="item">
                <Link to={`${Constants.HOME}messages/support`}>
                  General Billing Support
                </Link>
              </div>
              <div className="item">
                <a
                  href="https://epoch.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Epoch Billing Support
                </a>
              </div>
              <div className="item">
                <a
                  href="https://netvideogirls.com/report-video"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Content Removal
                </a>
              </div>
              <div className="item">
                <Link to={`${Constants.HOME}2257`}>
                  18 U.S.C. 2257 Record-Keeping Requirements Compliance
                  Statement
                </Link>
              </div>
            </div>
          </div>
          <div className="column second">
            <div className="logo_footer">
              <Link to={`${Constants.HOME}`}>
                <strong>NVG</strong>NETWORK
              </Link>
            </div>
            <div className="copy">
              &copy; NetVideoGirls.com, {year} - All Rights Reserved
            </div>
            <div className="copy">v20.42</div>
          </div>
        </div>
        <div className="copy_mobile">
          &copy; NetVideoGirls.com, {year} - All Rights Reserved
        </div>
        <div className="copy_mobile">v20.42</div>
      </div>
    </div>
  );
};

export default Footer;
